import { Storefront, Warehouse } from '@phosphor-icons/react'

export const locationTypes = {
  store: 'store',
  warehouse: 'warehouse',
}

export const locationLabels = {
  [locationTypes.warehouse]: 'Almacén',
  [locationTypes.store]: 'Tienda',
}

export const iconByLocationType = {
  [locationTypes.store]: Storefront,
  [locationTypes.warehouse]: Warehouse,
}
